import React  from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import cx from 'classnames';

// Styles.
import styles from './styles.module.scss';

const PageSecondaryMenuItem = (props) => {

  const onClickAdditionalMenuItem = () => {

    if (typeof props.item.onClickAdditionalMenuItem === 'function') {
      props.item.onClickAdditionalMenuItem();
    }
  };

  const { item, locationPath, classNameActiveMenu } = props;
  const isActiveMenuItem = locationPath.includes(item.to);
  const itemIconProps = {
    isActive: isActiveMenuItem,
  };
  const LinkComponent = item.href ? 'a' : Link;

  return (
    <LinkComponent href={item.href} to={{ pathname: `/${item.to}` }} onClick={item.onClick} className={cx({ [cx(styles.active, classNameActiveMenu)]: isActiveMenuItem })} >
      <MenuItem key={item.id} className={styles.userMenuLink} onClick={onClickAdditionalMenuItem}>
        {item.icon &&
          <ListItemIcon className={styles.userMenuLinkIcon}>
            {React.createElement(item.icon, itemIconProps)}
          </ListItemIcon>
        }
        <ListItemText inset primary={item.name} className={styles.userMenuLinkText} />
      </MenuItem>
    </LinkComponent>
  );

};

export default withStyles(styles)(PageSecondaryMenuItem);
